import { render, staticRenderFns } from "./HorsePerformanceChart.vue?vue&type=template&id=7a90ecf9&scoped=true&"
import script from "./HorsePerformanceChart.vue?vue&type=script&lang=js&"
export * from "./HorsePerformanceChart.vue?vue&type=script&lang=js&"
import style0 from "./HorsePerformanceChart.vue?vue&type=style&index=0&id=7a90ecf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a90ecf9",
  null
  
)

export default component.exports